import { combineReducers } from 'redux';
import edito from './edito';
import images from './images';
import diffusion from './diffusion';
import { INITIAL_DATA_LOAD_SUCCESS } from '../actions';

const isFetched = (state = false, action) => {
  switch (action.type) {
    case INITIAL_DATA_LOAD_SUCCESS:
      return true;
    default:
      return state;
  }
};

export default combineReducers({
  isFetched,
  diffusion,
  edito,
  images,
});

export const getIsFetched = state => state.isFetched;



// WEBPACK FOOTER //
// ./src/modules/calendar/reducers/index.js